<template>
  <div>
   <div class="md-layout">
    <div class="md-layout-item md-size-25" v-for="job in jobs" v-bind:key="job.id">
     <md-card>
        <md-card-header>
          <div class="md-title">{{job.name}}</div>
          <div class="md-subhead">{{job.id}} - {{job.description}}</div>
        </md-card-header>

        <md-card-content>
        {{percent(job)}}% - ({{job.completed}} / {{job.total}})
        <md-progress-bar md-mode="determinate" :md-value="percent(job)"></md-progress-bar>
        </md-card-content>

        <md-card-actions>
          <md-button :to="'/Job/'+job.id">open</md-button>
        </md-card-actions>
     </md-card>
    </div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'jobs',
  data: () => ({
    shownavigation: false,
    showsidepanel: false,
    jobs: []
  }),
  methods: {
    percent: function (job) {
      var pval = 100 * job.completed / job.total
      return parseFloat(pval.toFixed(1))
    }
  },
  created () {
  },
  mounted () {
    this.$root.loading = 1
    var self = this
    this.$auth.loaded().then(function () {
      self.axios.get('/api/datasets',
        {headers: { Authorization: `Bearer ${self.$auth.getAccessToken()}` }})
        .then(response => {
          self.jobs = response.data.Datasets
          self.$root.loading--
        }).catch(e => {
          console.error(e)
          self.$root.loading--
        })
    })
  }
}
</script>

<style lang="scss" >

</style>



// WEBPACK FOOTER //
// src/components/Jobs.vue